import * as bi from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import { IClientTripMonthPricesBrief } from '@bustickus/models-client';
import { Button, Flex, Loader, Message, TextContent } from 'components';
import { ApiTrips } from 'common/api';
import { Icon } from 'shared/components';
import { splitToWeeks } from './helpers';
import { ICalendarDate } from './types';
import './style.scss';

interface IProps {
  departureCityId: string;
  arrivalCityId: string;
  date: Date;
  onDateClick: (date: Date) => void;
}

type Stage = 'default' | 'loading' | 'error';

function StageDefault(props: IProps) {
  const [stage, setStage] = useState<Stage>('loading');
  const [prices, setPrices] = useState<IClientTripMonthPricesBrief | null>(null);

  useEffect(() => {
    loadPrices();
  }, [props.date]);

  const loadPrices = async () => {
    try {
      setStage('loading');

      const api = ApiTrips.getInstance();
      const prices = await api.prices(
        props.departureCityId,
        props.arrivalCityId,
        props.date.getFullYear(),
        props.date.getMonth() + 1
      );

      setPrices(prices);
      setStage('default');
    } catch {
      setStage('error');
    }
  };

  const handleDateClick = (day: ICalendarDate) => {
    const date = new Date(day.year, day.month, day.date);
    props.onDateClick(date);
  };

  const weekDays = ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'];

  return (
    <div className='prices-def-4HvB'>
      {stage === 'loading' && (
        <Flex
          className='loading-xbXC'
          alignItems='center'
          justifyContent='center'
        >
          <Loader
            variant='line'
            size='default'
            color='blue'
          />
        </Flex>
      )}
      {stage === 'error' && (
        <Flex
          direction='column'
          alignItems='center'
          gap={10}
          className='error-36lT'
        >
          <Message type='error'>
            <Flex
              direction='column'
              gap={20}
            >
              <div />
              <div />
              <Icon
                color='error'
                className='calendar-error-icon-C8FH'
              >
                <bi.CalendarX />
              </Icon>
              <TextContent align='center'>
                Ошибка загрузки календаря, попробуйте попытку позже или выберите другие пункты отправления-назначения!
              </TextContent>
              <div />
              <div />
              <Button
                size='small'
                color='transparent-red'
                onClick={loadPrices}
              >
                <Flex
                  gap={5}
                  alignItems='center'
                  justifyContent='center'
                >
                  <bi.ArrowClockwise />
                  <span>Попробовать ещё раз</span>
                </Flex>
              </Button>
            </Flex>
          </Message>
        </Flex>
      )}
      {stage === 'default' && prices != null && (
        <Flex
          direction='column'
          gap={5}
          className='calendar-iU6J'
        >
          <Flex>
            {weekDays.map((x, i) => (
              <Flex
                key={`${x}_${i}`}
                className={`week-day-LGXb header-cell-jssm ${i >= 5 ? 'weekend-99Ar' : ''}`}
                alignItems='flex-end'
                justifyContent='center'
                aria-disabled
              >
                {x}
              </Flex>
            ))}
          </Flex>
          {splitToWeeks(prices).map((week, i) => (
            <Flex key={i}>
              {week.map((day, i) => (
                <WeekDay
                  key={i}
                  weekIndex={i}
                  day={day}
                  onClick={() => handleDateClick(day)}
                />
              ))}
            </Flex>
          ))}
        </Flex>
      )}
    </div>
  );
}

function WeekDay(props: { weekIndex: number; day: ICalendarDate; onClick: () => void }) {
  let className = 'week-day-LGXb';

  if (props.weekIndex >= 5) {
    className += ' weekend-99Ar';
  }

  if (props.day.price == null) {
    className += ' no-price-6nRa';
  }

  const price =
    props.day.price != null
      ? new Intl.NumberFormat('ru-RU', {
          style: 'currency',
          currency: 'RUB',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(Math.floor(props.day.price))
      : '— ₽';

  return (
    <Flex
      className={className}
      direction='column'
      alignItems='center'
      justifyContent='space-between'
      aria-disabled={!props.day.show ? true : undefined}
      onClick={props.onClick}
    >
      <div></div>
      {props.day.show && (
        <Flex
          direction='column'
          alignItems='center'
        >
          <div>{props.day.date}</div>
          <div className='price-IxQG'>{price}</div>
        </Flex>
      )}
      <div></div>
    </Flex>
  );
}

export default StageDefault;
